import css from './style.module.scss';
import Header from "../../components/header";
import Wheel from "../../components/wheel";
import {FC, useEffect, useState} from "react";

type Props = {
    amount: number,
    onSpin: (prize: number, spinN: number) => void,
    isShowing: boolean,
    isPrev: boolean,
}

type SpinN = 1 | 2 | 3 | 4;

const S2: FC<Props> = ({
    amount,
    onSpin,
    isShowing,
    isPrev
}) => {
    const [spinN, setSpinN] = useState<SpinN>(1);
    const [chosen, setChosen] = useState<number[]>([]);
    const [currentPrize, setCurrentPrize] = useState<number | undefined>(undefined);

    useEffect(() => {
        if(amount === 1000000){
            setSpinN(1);
            setChosen([]);
            setCurrentPrize(undefined);
        }
    }, [amount])

    function spinHandler(prize: number){
        setChosen([...chosen, prize]);
        setCurrentPrize(prize);
        const currSpinN = spinN;
        setSpinN(currSpinN + 1 as SpinN);
        onSpin(prize, currSpinN);
    }

    const headerStatus = spinN === 1 ? "start" : "result";
    const type = isPrev ? "prev" : isShowing ? "show" : "hide";

    return (
        <div className={css.content} data-type={type}>
            <Header status={headerStatus} prize={currentPrize} sum={amount}/>
            <Wheel spinN={spinN} chosen={chosen} onSpin={spinHandler}/>
        </div>
    )
}
export default S2;